import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutAction } from '../actions/loginActions';

const navStyle = {
  background: '#151c43',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  padding: '0 32px',
  height: 54,
  marginBottom: 24,
};
const linkStyle = {
  color: '#fff',
  margin: '0 18px',
  textDecoration: 'none',
  fontWeight: 500,
  fontSize: 17,
  paddingBottom: 4,
  borderBottom: '2px solid transparent',
};
const activeLink = {
  borderBottom: '2px solid #fff',
};

export default function UserNav() {
  const location = useLocation();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutAction());
    window.location.href = '/login';
  };
  return (
    <nav style={navStyle}>
      <Link to="/usertests" style={{ ...linkStyle, ...(location.pathname === '/usertests' ? activeLink : {}) }}>Tests</Link>
      <Link to="/profile" style={{ ...linkStyle, ...(location.pathname === '/profile' ? activeLink : {}) }}>Profile</Link>
      <Link to="/results" style={{ ...linkStyle, ...(location.pathname === '/results' ? activeLink : {}) }}>Results</Link>
      <span onClick={handleLogout} style={{ ...linkStyle, cursor: 'pointer', marginLeft: 'auto', color: '#ffb3b3' }}>Logout</span>
    </nav>
  );
} 